import { ModelCommon } from './ModelCommon'
import { PossibleBusinessObject, ValidBusinessObject, ValueTypes } from '../types'
import { UserAttributeDefs, MapObject } from '../types/ModelTypes'
import { GeofenceRuleType } from '../ModelClassInterfaces'

const debug = !process.env.AWS_SESSION_TOKEN && false
const typeId = 'GeofenceRule'

class GeofenceRule extends ModelCommon implements GeofenceRuleType {
  constructor(ob: PossibleBusinessObject & Partial<GeofenceRuleType>) {
    super(typeId, ob)
    this.enabled = ob.enabled
    this.allowed = ob.allowed
    this.geofence = ob.geofence
    if (ob) {
      const userAttDefs: UserAttributeDefs = this.getUserAttributes()
      Object.entries(userAttDefs).forEach(([key, def]) => {
        if (def && Object.getOwnPropertyDescriptor(def, 'default') && ob[key] === undefined) {
          this[key] = def.default
        }
      })
    }
  }

  enabled?: boolean | undefined
  allowed?: boolean | undefined
  geofence?: ValidBusinessObject | undefined

  isSaveable() {
    return false
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      name: { type: 'String' },
      description: { type: 'String' },
      enabled: { type: 'Boolean', default: false },
      allowed: {
        type: 'Boolean',
        default: false,
        label: (currentSetting: ValueTypes) =>
          currentSetting === true ? 'Permitted in this area, alert if outside' : 'Prohibited in this area, alert if inside',
      },
      geofence: {
        type: 'Derived',
        valueFn: (state: MapObject, functions: Function[], accessKey: string) => {
          debug &&
            console.log(
              `GeofenceRule valueFunction with geofence ${this.geofence ? this.geofence.id : 'no geofence'} and ids of Geofences available`,
              state.userView.Geofence.map((g: MapObject) => g.id),
            )
          const geofence =
            this.geofence && this.geofence.id ? (state.userView?.Geofence).find((geofence: MapObject) => (geofence.id = this.geofence?.id)) : undefined
          debug && console.log(`GeofenceRule valueFunction returning`, geofence)
          //parentObject, attKey, parentKey
          return { geofence, functions, parentObject: this, attKey: 'geofence', parentKey: accessKey }
        },
        viewName: 'GeofenceDetails',
      },
      failMessage: { type: 'String' },
    }
  }
}

export { GeofenceRule }
